<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Przepięcie polisy
  </div>

  <div  fxFlex="100">
    <app-dict-registrations fxFlex="100" label="Rejestracja" [control]="registrationControl" [required]="true"
                            [contractStatus]="true" [status]="true" [rau]="true" [filterInsuranceCompany]="insuranceCompany"
    ></app-dict-registrations>
  </div>
  <div  fxFlex="100">
    <app-dict-receivables-balance fxFlex="100" label="Saldo" [formControl]="receivablesBalanceControl">
    ></app-dict-receivables-balance>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

